import * as React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ReactPlayer from "react-player";
import { BaseDialog } from "../dialog/BaseDialog";
import { colors } from "../../theme/colors";


interface VideoPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  content: string | null;
  videoUrl: string | null;
  onError: (e: any) => void;
}

export const VideoPreviewDialog: React.FC<VideoPreviewDialogProps> = ({
  open,
  onClose,
  content,
  videoUrl,
  onError,
}) => {
  return (
    <BaseDialog open={open} onClose={onClose} aria-labelledby="video-dialog">
      <DialogTitle
        sx={{
          backgroundColor: colors.primary,
          color: "white",
          fontWeight: "bold",
          fontSize: "23px",
        }}
        id="video-dialog-title"
        align="center"
      >
        {content}
      </DialogTitle>
      <IconButton
        aria-label="close-video-dialog"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <div className="player-wrapper">
          <ReactPlayer
            url={videoUrl!}
            className="react-player"
            controls
            width="100%"
            height="100%"
            onError={onError}
          />
        </div>
      </DialogContent>
    </BaseDialog>
  );
};